/*
 * Relocates the Booster/baCurr currency widget between the header and the menu drawer.
 * Extracted from snippets/header-actions.liquid so it is cached across page views rather
 * than re-sent inline in every HTML response.
 *
 * The widget is injected asynchronously by the Nova Multi Currency Converter app embed, so
 * this picks up an already-present widget and also observes for a later one. That is what
 * makes it safe to load deferred.
 */
(function () {
  /* 750px is where the burger disappears, so that is where the switcher has
     to move from the menu drawer into the header. */
  var desktopQuery = window.matchMedia('(min-width: 750px)');
  var queued = false;
  var settleTimer = null;
  var watched = null;
  var lastStyle = '';
  var tracking = false;
  var trackUntil = 0;
  var holdHidden = false;
  var holdTimer = null;

  function widgetBlock() {
    var widgets = document.querySelectorAll('.bacurr-cur-blocker');
    for (var i = widgets.length - 1; i >= 0; i--) {
      var block = widgets[i].querySelector('.bacurr-cur-block');
      if (block && block.querySelector('.bacurr-choiceDesign')) return block;
    }
    return null;
  }

  /* Neither drawer signal is usable on its own, because each one is late at a
     different end. `open` is set on the tap but the theme keeps it for the whole
     slide-out and only clears it on animationend, so it cannot say when to leave.
     `menu-open` is dropped the instant the close starts but is added a frame after
     the tap, so it cannot say when to arrive. `open` without `menu-open` is
     therefore the opening frame the first time around, and the slide-out once the
     panel has actually been on screen. The pill is fixed and cannot travel with the
     panel, so it has to be in place before the slide in and gone before the slide
     out rather than trailing after it. */
  var panelWasOnScreen = false;

  function drawerOpen() {
    var details = document.querySelector('#Details-menu-drawer-container');
    if (!details || !details.hasAttribute('open')) {
      panelWasOnScreen = false;
      return false;
    }
    if (details.classList.contains('menu-open')) {
      panelWasOnScreen = true;
      return true;
    }
    return !panelWasOnScreen;
  }

  /* A sliding panel like Games covers the Currency row, so the pill has to
     leave with it and come back when the panel closes. */
  function submenuOpen() {
    return !!document.querySelector(
      '.menu-drawer details[open] > .menu-drawer__submenu:not(.menu-drawer__menu--childlist), .menu-drawer details.menu-open > .menu-drawer__submenu:not(.menu-drawer__menu--childlist)'
    );
  }

  /* The app's own stylesheet transitions the pill for 0.5s. An inline cancel
     beats that, including the mobile reset that unsets transitions. */
  function freezeMotion(el) {
    el.style.setProperty('transition', 'none', 'important');
    el.style.setProperty('animation', 'none', 'important');
  }

  function conceal(block) {
    var pill = block.querySelector('.bacurr-choiceDesign');
    freezeMotion(block);
    if (pill) {
      freezeMotion(pill);
      pill.style.setProperty('opacity', '0', 'important');
      pill.style.setProperty('visibility', 'hidden', 'important');
    }
    block.classList.remove('is-anchored-header', 'is-anchored-drawer');
    block.style.setProperty('opacity', '0', 'important');
    block.style.setProperty('visibility', 'hidden', 'important');
    block.style.setProperty('pointer-events', 'none', 'important');
    lastStyle = block.getAttribute('style');
  }

  /* The app rewrites the widget's inline styles on scroll, which drops it
     back into its own corner until our next tick. Catch that write and undo
     it in the same frame so it never paints there. */
  function watch(block) {
    if (watched === block) return;
    watched = block;
    new MutationObserver(function () {
      if (block.getAttribute('style') !== lastStyle) align();
    }).observe(block, { attributes: true, attributeFilter: ['style'] });
  }

  function align() {
    var block = widgetBlock();
    if (!block) return;
    watch(block);

    var desktop = desktopQuery.matches;
    document.documentElement.classList.add('currency-ready');

    /* While the viewport is being dragged, the app keeps resetting the widget
       to its own corner placement and we keep pulling it back, which strobes.
       Park it until the size settles, then place it once. */
    if (submenuOpen()) holdHidden = false;

    /* holdHidden covers the gap between the tap and the submenu actually
       opening, so the pill cannot snap back on screen for that frame. */
    if (holdHidden || settleTimer || (!desktop && (!drawerOpen() || submenuOpen()))) {
      conceal(block);
      return;
    }

    var slot = desktop
      ? document.querySelector('[data-header-currency-switcher]')
      : document.querySelector('[data-header-currency-switcher-drawer]');
    if (!slot) return;

    if (desktop) {
      var sized = block.querySelector('.bacurr-choiceDesign') || block;
      var fitted = Math.ceil(sized.getBoundingClientRect().width);
      if (fitted > 8) {
        slot.style.width = fitted + 'px';
        slot.style.flexBasis = fitted + 'px';
      }
    }

    var rect = slot.getBoundingClientRect();
    if (rect.width < 2 || rect.height < 2) return;

    /* The drawer scrolls, so hide the pill rather than leave it floating
       over the menu once its row has scrolled out of sight. */
    if (rect.bottom < 4 || rect.top > window.innerHeight - 4) {
      conceal(block);
      return;
    }

    var slotStyles = window.getComputedStyle(slot);
    var padTop = parseFloat(slotStyles.paddingTop) || 0;
    var padBottom = parseFloat(slotStyles.paddingBottom) || 0;
    var padRight = parseFloat(slotStyles.paddingRight) || 0;
    var innerTop = rect.top + padTop;
    var innerHeight = rect.height - padTop - padBottom;
    var innerRight = rect.right - padRight;

    var pillEl = block.querySelector('.bacurr-choiceDesign');
    freezeMotion(block);
    if (pillEl) {
      freezeMotion(pillEl);
      pillEl.style.removeProperty('opacity');
      pillEl.style.removeProperty('visibility');
    }

    block.classList.add(desktop ? 'is-anchored-header' : 'is-anchored-drawer');
    block.classList.remove(desktop ? 'is-anchored-drawer' : 'is-anchored-header');

    /* The pill sits slightly inset in the app's wrapper, so offset the
       wrapper by that inset and align the pill itself to the slot. */
    var box = block.getBoundingClientRect();
    var pill = block.querySelector('.bacurr-choiceDesign').getBoundingClientRect();
    var top = (innerTop + (innerHeight - pill.height) / 2 - (pill.top - box.top)).toFixed(2);
    var left = (innerRight - (pill.right - box.right) - box.width).toFixed(2);
    block.style.setProperty('position', 'fixed', 'important');
    block.style.setProperty('top', top + 'px', 'important');
    block.style.setProperty('left', left + 'px', 'important');
    block.style.setProperty('right', 'auto', 'important');
    block.style.setProperty('bottom', 'auto', 'important');
    block.style.setProperty('transform', 'none', 'important');
    block.style.setProperty('margin', '0', 'important');
    block.style.setProperty('width', 'auto', 'important');
    block.style.setProperty('height', 'auto', 'important');
    block.style.setProperty('z-index', '10000', 'important');
    block.style.setProperty('display', 'inline-block', 'important');
    block.style.setProperty('visibility', 'visible', 'important');
    block.style.setProperty('pointer-events', 'auto', 'important');
    block.style.setProperty('opacity', '1', 'important');
    lastStyle = block.getAttribute('style');
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      align();
    });
  }

  /* The sticky header and the drawer both animate, so one pass per event
     leaves the pill a frame behind. Keep re-aligning until the motion ends. */
  function track() {
    if (window.performance.now() > trackUntil) {
      tracking = false;
      return;
    }
    align();
    window.requestAnimationFrame(track);
  }

  function startTracking() {
    trackUntil = window.performance.now() + 350;
    if (tracking) return;
    tracking = true;
    window.requestAnimationFrame(track);
  }

  /* On a phone with the drawer shut the pill is hidden, so a page or carousel scroll has
     nothing to follow - but tracking it rewrote the widget's styles every frame of every
     scroll. The app's own rewrites are still caught by watch(), and the drawer opening
     starts tracking through its observers below. */
  function handleScroll() {
    if (!desktopQuery.matches && !drawerOpen()) return;
    startTracking();
  }

  function scheduleAfterSettle() {
    if (settleTimer) window.clearTimeout(settleTimer);
    settleTimer = window.setTimeout(function () {
      settleTimer = null;
      schedule();
    }, 180);
    schedule();
  }

  schedule();
  desktopQuery.addEventListener('change', scheduleAfterSettle);
  window.addEventListener('resize', scheduleAfterSettle);
  window.addEventListener('scroll', handleScroll, { capture: true, passive: true });
  window.setInterval(schedule, 500);

  var details = document.querySelector('#Details-menu-drawer-container');
  if (details) {
    new MutationObserver(startTracking).observe(details, { attributes: true, attributeFilter: ['class', 'open'] });
  }

  var drawer = document.querySelector('.menu-drawer');
  if (drawer) {
    new MutationObserver(startTracking).observe(drawer, {
      attributes: true,
      subtree: true,
      attributeFilter: ['open', 'class'],
    });
  }

  /* Hide on the tap itself, before the submenu's slide starts. */
  document.addEventListener(
    'pointerdown',
    function (event) {
      var summary = event.target.closest && event.target.closest('.menu-drawer summary');
      if (!summary) return;
      var details = summary.parentElement;
      if (!details) return;
      var submenu = details.querySelector('.menu-drawer__submenu');
      if (!submenu || submenu.parentElement !== details || submenu.classList.contains('menu-drawer__menu--childlist')) return;
      holdHidden = true;
      if (holdTimer) window.clearTimeout(holdTimer);
      holdTimer = window.setTimeout(function () {
        holdHidden = false;
        schedule();
      }, 450);
      var block = widgetBlock();
      if (block) conceal(block);
    },
    true
  );

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (
          (node.classList && node.classList.contains('bacurr-cur-blocker')) ||
          (node.querySelector && node.querySelector('.bacurr-cur-block'))
        ) {
          align();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
